// src/pages/SignupAcademy.js
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/SignupAcademy.css"; 
import axios from "axios";

const days = [
  { id: 1, name: "Mandag" },
  { id: 2, name: "Tirsdag" },
  { id: 3, name: "Onsdag" },
  { id: 4, name: "Torsdag" },
  { id: 5, name: "Fredag" },
  { id: 6, name: "Lørdag" },
  { id: 7, name: "Søndag" },
];

const ProfileAcademy = () => {
  const location = useLocation();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    age: "",
    parent_name: "",
    parent_email: "",
    parent_phone: "",
    ingame_name: "",
    game_id: location.state?.game_id || "",
    game_name: location.state?.game || "",
    training_time: location.state?.training_time || "",
    day_id: location.state?.day || "",
    day_name: "",
    level: location.state?.level || ""
  });

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [personalId, setPersonalId] = useState("");

  // Map day_id til navn
  useEffect(() => {
    if (form.day_id) {
      const dayObj = days.find(d => d.id === Number(form.day_id));
      if (dayObj) {
        setForm(prev => ({ ...prev, day_name: dayObj.name }));
      }
    }
  }, [form.day_id]);

  // Hent bruger fra session
  useEffect(() => {
    axios.get("https://linxlegacyacademy.dk/auth/user", { withCredentials: true })
      .then(res => {
        if (res.data.status === "logged_in") {
          setUser(res.data);
          setForm(prev => ({ ...prev, name: res.data.username || "", email: res.data.email || "" }));
        }
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // Submit med personal_id
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setPersonalId("");

    try {
      const res = await axios.post(
        "https://linxlegacyacademy.dk/api/academy/signup",
        form,
        { withCredentials: true }
      );

      if (res.data.status === "success") {
        setPersonalId(res.data.personal_id);
        setMessage(`Tilmelding gennemført! Dit ID: ${res.data.personal_id} 🎉`);
      } else {
        setMessage(res.data.error || "Ukendt fejl");
      }
    } catch (err) {
      setMessage(err.response?.data?.error || "Fejl ved tilmelding.");
    }
  };

  if (loading) return <p>Loader...</p>;

  const under18 = parseInt(form.age || 0) < 18;

  return (
    <div className="signup-page">
      <h1>Bliv medlem af Linx Legacy Academy</h1>

      <section className="instructions">
        <h2>Sådan gør du</h2>
        <ol>
          <li>Vælg det spil du vil spille og tidspunkt du kan.</li>
          <li>Prøv 1 gratis træning – mød bare op eller kontakt os inden.</li>
          <li>Aktiver dit medlemskab.</li>
        </ol>
        <p>Prisen for alle spil og tider er <strong>2000kr / halvår</strong>.</p>
      </section>

<section className="game-info">
  <h3>Vælg dit spil</h3>
  <p>Spil, dag, træningstid og level er udfyldt for dig:</p>
  <ul>
    <li><strong>Spil:</strong> {form.game_name || "Ikke valgt"}</li>
    <li><strong>Dag:</strong> {form.day_name || "Ikke valgt"}</li>
    <li><strong>Træningstid:</strong> {form.training_time || "Ikke valgt"}</li>
    <li><strong>Level:</strong> {form.level || "Ikke valgt"}</li>
  </ul>
  
  <p>Vil du ændre spil eller tid? Klik på knappen herunder:</p>
  <a 
    href="https://linxlegacyacademy.dk/Gametime" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="btn primary"
    style={{ display: "inline-block", marginTop: "8px" }}
  >
    Vælg spil og tider
  </a>
</section>

      {/* Discord login */}
      <div className="connect-section">
        <button
          onClick={() => window.location.href = "/auth/discord/login?type=academy"}
          disabled={!!user}
          className="btn primary"
        >
          {user ? "Discord logget ind" : "Login med Discord"}
        </button>
        {user && <span>✅</span>}
      </div>

      {!user && <p>Du skal være logget ind med Discord for at tilmelde dig</p>}

      <form onSubmit={handleSubmit} className="signup-form">
        <h2>Udfyld oplysningerne</h2>

        <label>Navn:</label>
        <input type="text" name="name" value={form.name} onChange={handleChange} required />

        <label>Email:</label>
        <input type="email" name="email" value={form.email} onChange={handleChange} required />

        <label>Telefon:</label>
        <input type="text" name="phone" value={form.phone} onChange={handleChange} required />

        <label>Alder:</label>
        <input type="number" name="age" value={form.age} onChange={handleChange} required />

        {under18 && (
          <>
            <h3>Forældre info (under 18 år)</h3>

            <label>Forældre navn:</label>
            <input type="text" name="parent_name" value={form.parent_name} onChange={handleChange} required />

            <label>Forældre email:</label>
            <input type="email" name="parent_email" value={form.parent_email} onChange={handleChange} required />

            <label>Forældre telefon:</label>
            <input type="text" name="parent_phone" value={form.parent_phone} onChange={handleChange} required />
          </>
        )}

        <label>Ingame navn:</label>
        <input type="text" name="ingame_name" value={form.ingame_name} onChange={handleChange} />

        {/* Vis personal_id efter tilmelding */}
        {personalId && (
          <>
            <label>Dit Personlige ID:</label>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <input type="text" value={personalId} readOnly />
              <button type="button" onClick={() => navigator.clipboard.writeText(personalId)}>Kopier</button>
            </div>
          </>
        )}

        <button type="submit" className="btn-signup" disabled={!user}>Aktiver medlemskab</button>
      </form>

      {message && <p>{message}</p>}
    </div>
  );
};

export default ProfileAcademy;